import { AppState } from "../rootReducer";

export const getClientLogo = (state: AppState) => state.client.logo;

export const getClientName = (state: AppState) => state.client.name;

export const getHasCustomOnboarding = (state: AppState) =>
  state.client.hasCustomOnboarding;

export const getDefaultUserSkills = (state: AppState) =>
  state.client.defaultUserSkills;

export const getIsCoachingAccount = (state: AppState) =>
  state.client.isCoachingAccount;

export const getIsPhoneNumberRequired = (state: AppState) =>
  state.client.isPhoneNumberRequired;

export const getRequesting = (state: AppState) => state?.client?.requesting || false;
